export const ROUTES = {
	HOME: '/'
};
